class InstantCartAttackGuard {
  constructor() {
    this.cartAddTimestamps = [];
    this.pageViewDetected = false;
    this.sessionStartTime = Date.now();
    
    this.CONFIG = {
      MAX_ITEMS_PER_SECOND: 2,
      MAX_ITEMS_PER_5_SECONDS: 4,
    };

    this.recordPageView();
  }

  recordPageView() {
    this.pageViewDetected = true;
  }

  trackCartAddition(productId, sku, price) {
    const now = Date.now();
    this.cartAddTimestamps.push(now);

    // CHECK 1: Headless bot
    if (!this.pageViewDetected) {
      window.CART_IS_BOT = true;
      return {
        valid: false,
        reason: 'Headless bot detected',
        botScore: 99,
        detectedPattern: 'Headless API attack'
      };
    }

    // CHECK 2: Rapid-fire
    const itemsInLastSecond = this.cartAddTimestamps.filter(
      ts => now - ts < 1000
    ).length;

    if (itemsInLastSecond > this.CONFIG.MAX_ITEMS_PER_SECOND) {
      window.CART_IS_BOT = true;
      return {
        valid: false,
        reason: 'Items added too rapidly',
        botScore: 95,
        detectedPattern: 'Instant cart stack attack'
      };
    }

    // CHECK 3: Burst attack
    const itemsInLast5Seconds = this.cartAddTimestamps.filter(
      ts => now - ts < 5000
    ).length;

    if (itemsInLast5Seconds > this.CONFIG.MAX_ITEMS_PER_5_SECONDS) {
      window.CART_IS_BOT = true;
      return {
        valid: false,
        reason: 'Too many items added too quickly',
        botScore: 90,
        detectedPattern: 'Multi-item rapid fire'
      };
    }

    return {
      valid: true,
      botScore: 0
    };
  }
}

let instantCartGuard = new InstantCartAttackGuard();